import axios from "axios";
import config from "app/api/axiosConfig";

import { IServiceCategory } from "app/api/types";

export default (token: string, data: IServiceCategory["id"]) =>
  axios.delete(
    `${process.env.REACT_APP_API_HOST}/admin/categories?id=${data}`,
    config(token)
  );
